import { parseStrToFloatInputBRL } from './parseStrToFloatInputBRL';

export default function validatorBiggerZero(value) {
  const floatValue = parseStrToFloatInputBRL(value);

  if (+floatValue > 0) return true;

  return false;
}
